<template>
	<div>
		<h2>dictionary</h2>
		<select v-model="lang" s>
			<option disabled>lang</option>
			<option value="de">deutsch</option>
			<option value="it">italiano</option>
			<option value="en">english</option>
		</select>
		<br />
		<input type="checkbox" v-model="is_only_missing" />only show missing trans
		<input type="checkbox" v-model="is_hide_numbers" />hide number

		<div style="display: flex; position: relative; min-height:420px">
			<div v-if="words_list" style="flex: 9">
				<h5>words</h5>
				<div v-for="({ word, trans }, index) in words_list" :key="index">
					<div v-if="is_show_word(word, trans)" @click="select(word)">
						<div
							style="cursor: pointer"
							:style="
								word === selected_word ? 'color: blue; font-size: 42px' : ''
							"
						>
							{{ word }}
						</div>
					</div>
				</div>

				<div style="position: absolute; top: 0; right: 20px; flex: 1;">
					<div v-if="selected_word">
						<h3>{{ selected_word }}</h3>
						<div>
							<input
								placeholder="translation"
								v-model="manual_trans"
								@keyup.enter="add_trans"
							/>
							<button @click="add_trans">
								add trans
							</button>
						</div>
						<div>
							<input
								placeholder="link reroute input"
								v-model="reroute_text"
								@keyup.enter="add_link"
							/>
							<button @click="add_link">
								add link
							</button>
						</div>
						<div>
							<button @click="find_word">
								find word
							</button>
							<div v-if="search">
								<p v-for="(text, index) in search" :key="index">
									{{ text }}
								</p>
							</div>
						</div>
						<div>
							<button @click="get_from_other_lang">
								get from {{ get_lang_name(lang) }}
								(WARNING: deprecated doesn't tell which lang)
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { db } from "../../firebase";

export default {
	data() {
		return {
			words_list: null,
			is_only_missing: true,
			lang: "en",
			selected_word: "",
			manual_trans: "",
			reroute_text: "",
			search: null,
			is_hide_numbers: true,
		};
	},
	watch: {
		lang(lang) {
			this.get_words(lang);
		},
	},
	created() {
		this.get_words(this.lang);
	},
	methods: {
		async find_word() {
			let songs;
			if (this.songs) songs = this.songs;
			else {
				songs = await db
					.collection("songs")
					.get()
					.then((docs) => docs.docs.map((doc) => doc.data()));
				this.songs = songs;
			}
			songs
				.filter((s) => s.lang === this.lang)
				.forEach(({ id, parsed_lines }) => {
					parsed_lines.forEach(({ split_it, split_fr, split_de }) => {
						const split = split_it || split_de;
						if (split) {
							if (
								split.find((word) => this.format(word) === this.selected_word)
							) {
								const format = (word) => word.toString().replaceAll(",", " ");
								this.search = [id, format(split), format(split_fr)];
							}
						}
					});
				});
		},
		async get_words(lang) {
			this.words_list = await db
				.collection(lang + "_dictionary")
				.get()
				.then((docs) => docs.docs.map((doc) => doc.data()));
		},
		select(word) {
			this.$clipboard(word);
			if (word === this.selected_word) {
				this.selected_word = "";
				return;
			}
			this.selected_word = word;
			this.find_word();
		},
		format(word) {
			return word.replace(this.$regex, "").toLowerCase();
		},
		get_selected_ref(is_other_lang) {
			let lang = this.lang;
			if (is_other_lang) null; // lang = other lang ???;
			return db
				.collection(lang + "_dictionary")
				.doc(this.format(this.selected_word));
		},
		async get_from_other_lang() {
			const other_ref = this.get_selected_ref(true);
			const word_ref = this.get_selected_ref();
			const { trans } = await other_ref.get().then((doc) => doc.data());
			word_ref.update({ trans, is_other_lang: true });
			this.remove_selected();
		},
		add_trans() {
			const { manual_trans } = this;
			const trans = manual_trans.split("/").map((text) => ({ text }));
			this.get_selected_ref().update({ trans });
			this.remove_selected();
			this.manual_trans = "";
		},
		async add_link() {
			const { reroute_text } = this;
			await this.get_selected_ref().update({ reroute: reroute_text });
			this.reroute_text = "";
		},
		remove_selected() {
			const { words_list, selected_word } = this;
			const index = words_list.findIndex((el) => el.word === selected_word);
			let new_words_list = words_list;
			new_words_list[index].trans = "ADDED";
			this.words_list = new_words_list;
			this.selected_word = "";
		},

		is_show_word(word, trans) {
			if (this.is_hide_numbers && (parseInt(word) || word === "0"))
				return false;
			if (this.is_only_missing) {
				if (trans === "UNFETCHED") return true;
				else return false;
			}
			return true;
		},
		get_lang_name(lang) {
			if (lang === "it") return "italiano";
			if (lang === "de") return "deutsch";
			if (lang === "en") return "english";
		},
	},
};
</script>

<style scoped>
button {
	cursor: pointer;
	color: blue;
	text-decoration: underline;
	border: 0;
	background-color: white;
}
</style>
